module.exports = __webpack_public_path__ + "static/media/background.855c6420.png";